import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import {
	CompetenceElementaireSESSAD,
	CompetenceSSIAD,
	CompetenceSESSAD,
	CompetenceSAAD
} from 'src/app/shared/enums/competence.enum';
import { User } from 'src/app/shared/models/security/user';
import { Employee } from 'src/app/shared/models/employee/employee';
import { saveAs } from 'file-saver';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { Expertise } from 'src/app/shared/models/expertise';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EmployeeModalAjoutComponent } from '../modal/employee-modal-ajout/employee-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { EmployeeType, EmployeeTypeString } from 'src/app/shared/models/employee/employee-type';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-employee',
	templateUrl: './list-employee.component.html',
	styleUrls: ['./list-employee.component.scss']
})
export class ListEmployeeComponent implements OnInit {
	LABEL_INTERVENANT: string;
	LABEL_INTERVENANT_CAPITALIZED;
	LABEL_INTERVENANT_PLURIALIZED: string;

	employees: Employee[] = [];
	currentPage = 0;

	employeeCsvFile: File = null;

	dismissible: true;
	alerts: any[] = [];
	user: User = null;

	isAddable = true;
	isImportable = false;
	isExportable = false;

	sortType = 'lastName';
	sortOrder: SortOrder = 'asc';

	selectedExperises: string[] = [];
	searchedText: string;

	listExpertise: Expertise[];
	listSelectedExpertise: Expertise[] = [];

	ajoutIntervenantModalref: BsModalRef;

	itemsPerPage = 10;

	isMobile = false;
	screenWidth: number;

	isListingLoading: boolean = true;

	employeeTypeString = EmployeeTypeString;
	employeeType = EmployeeType;

	constructor(
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.LABEL_INTERVENANT_CAPITALIZED =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.LABEL_INTERVENANT_PLURIALIZED =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_INTERVENANT
			);

		this.user = this.facade.dataStorageService.getUser();

		this.getEmployees();
	}

	getEmployees(): void {
		this.isListingLoading = true;
		this.facade.employeeService.getAllActiveEmployees().subscribe({
			next: (employees: Employee[]) => {
				this.employees = employees;
				console.log(this.employees);
				this.listExpertise = this.getEmployeesExpertises(this.employees);
				this.currentPage = 1;
				this.itemsPerPage = this.employees.length >= 5 ? 10 : 5;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
			}
		});
	}

	getEmployeesExpertises(employees: Employee[]): Expertise[] {
		return employees
			.flatMap((employee) => employee.expertises)
			.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
			.sort((a, b) => a.name.localeCompare(b.name));
	}


	selectEmployee(employee: Employee): void {
		const link = ['/employees', employee.id];
		this.router.navigate(link);
	}

	// getEmployeesSpecialities(employees: Employee[]): Expertise[] {
	// 	return employees
	// 		.flatMap((employee) => employee.specialties)
	// 		.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
	// 		.sort((a, b) => a.name.localeCompare(b.name));
	// }

	importEmployees(event: any): void {
		this.isImportable = false;
		this.logger.log("Import de l'employee");
		this.alerts = [];
		this.employeeCsvFile = event.target.files[0];
		this.facade.employeeService
			.importEmployees(this.employeeCsvFile)
			.subscribe({
				next: (res: ImportResponse) => {
					this.isImportable = true;

					this.logger.log("C'est importé !");

					this.getEmployees();
				},
				error: (err) => {
					this.isImportable = true;
					this.logger.log("C'est PAS importé !", err.message);
					this.facade.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		const initialState = {};
		this.ajoutIntervenantModalref = this.modalService.show(
			EmployeeModalAjoutComponent,
			{
				class: 'modal-lg',
				initialState,
				backdrop: 'static'
			}
		);

		this.ajoutIntervenantModalref.onHide.subscribe((reason: string | any) => {
			this.getEmployees();
		});
	}

	exportEmployees(): void {
		this.facade.exportService
			.exportEmployees()
			.subscribe((blob) => saveAs(blob, 'employees.csv'));
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	// /**
	//  * Ajoute ou supprime la spécialité à la liste des spécialités sélectionnées
	//  * @param e Element html
	//  * @param spe String representant la expertise choisie
	//  */
	updateSelectedExpertise(e: any, spe: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertise.some((e) => e.id === spe.id)) {
				this.listSelectedExpertise = [...this.listSelectedExpertise];
				this.listSelectedExpertise.push(spe);
			}
		} else {
			if (this.listSelectedExpertise.some((e) => e.id === spe.id)) {
				this.listSelectedExpertise = this.listSelectedExpertise.filter(
					(e) => e.id !== spe.id
				);
			}
		}
	}

	checkIfEmployeeExt(employee: Employee): boolean{
		if(employee.statutInt == this.employeeType.EXT)
		return true;
	}

	updateSessionUser(employee: Employee): void{
		this.facade.dataStorageService.setOldUser(this.facade.dataStorageService.getUser());
		this.facade.userService.getUserById(employee.id).subscribe({
			next: (val) => {
				console.log(val);
				this.facade.dataStorageService.setUser(val);
				this.router.navigate(['dashboard']).then(() => {
					window.location.reload();
				});
			}
		})
	}
}
